<template>
  <v-toolbar
    v-if="$route.meta && $route.meta.isFrontend == false"
    id="core-toolbar"
    flat
    dense
    style="background: #eee"
  >
    <div class="v-toolbar-title">
      <v-toolbar-title class="tertiary--text font-weight-light">
        <v-btn
          v-if="responsive"
          class="default v-btn--simple"
          dark
          icon
          @click.stop="onClickBtn"
        >
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer />
    <v-toolbar-items>
      <v-flex align-center layout py-2>
        <!--        <v-text-field-->
        <!--          v-if="responsiveInput"-->
        <!--          class="mr-4 mt-2 purple-input"-->
        <!--          label="Search..."-->
        <!--          hide-details-->
        <!--          color="purple"-->
        <!--        />-->
        <router-link v-ripple class="toolbar-items" to="/">
          <v-icon color="tertiary">mdi-view-dashboard</v-icon>
        </router-link>
        <!--<v-menu-->
        <!--bottom-->
        <!--left-->
        <!--content-class="dropdown-menu"-->
        <!--offset-y-->
        <!--transition="slide-y-transition">-->
        <!--<router-link-->
        <!--v-ripple-->
        <!--slot="activator"-->
        <!--class="toolbar-items"-->
        <!--to="/notifications"-->
        <!--&gt;-->
        <!--<v-badge-->
        <!--color="error"-->
        <!--overlap-->
        <!--&gt;-->
        <!--<template slot="badge">-->
        <!--{{ notifications.length }}-->
        <!--</template>-->
        <!--<v-icon color="tertiary">mdi-bell</v-icon>-->
        <!--</v-badge>-->
        <!--</router-link>-->
        <!--<v-card>-->
        <!--<v-list dense>-->
        <!--<v-list-tile-->
        <!--v-for="notification in notifications"-->
        <!--:key="notification"-->
        <!--@click="onClick"-->
        <!--&gt;-->
        <!--<v-list-tile-title-->
        <!--v-text="notification"-->
        <!--/>-->
        <!--</v-list-tile>-->
        <!--</v-list>-->
        <!--</v-card>-->
        <!--</v-menu>-->
        <!-- <router-link
          v-ripple
          class="toolbar-items"
          to="/user-profile"
        >
          <v-icon color="tertiary">mdi-account</v-icon>
        </router-link> -->
        <div>
          {{ user.auth.email }}
        </div>
        <v-btn
          small
          dark
          color="error"
          class="ml-2"
          @click="$store.dispatch('user/logout')"
        >
          Logout
        </v-btn>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
  import { mapMutations, mapGetters } from "vuex";

  export default {
    data: () => ({
      notifications: [
        `5 new businesses to approve`,
        `1 outstanding payment`,
        `15 new customer enquiries`,
      ],
      title: null,
      responsive: false,
      responsiveInput: false,
    }),
    computed: {
      ...mapGetters(["user"]),
    },
    watch: {
      $route(val) {
        this.title = val.name;
      },
    },

    mounted() {
      this.onResponsiveInverted();
      window.addEventListener("resize", this.onResponsiveInverted);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.onResponsiveInverted);
    },

    methods: {
      ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
      onClickBtn() {
        this.setDrawer(!this.$store.state.app.drawer);
      },
      onClick() {
        //
      },
      onResponsiveInverted() {
        if (window.innerWidth < 991) {
          this.responsive = true;
          this.responsiveInput = false;
        } else {
          this.responsive = false;
          this.responsiveInput = true;
        }
      },
    },
  };
</script>

<style>
  #core-toolbar a {
    text-decoration: none;
  }

  #core-toolbar .v-toolbar__content {
    min-height: unset;
    padding-top: 0px;
    padding-bottom: 0px;
  }
</style>
